import { FieldArray } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';

const FieldArrayItem = (props) => {
   return (
      <Label
         className='d-block'
      >
         { props.label }
         <FieldArray
            {
               ...props
            }
         />
      </Label>
   );
};

FieldArrayItem.propTypes = {
   label: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   component: PropTypes.func.isRequired,
   options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
   })),
};

FieldArrayItem.defaultProps = {
   options: undefined,
};


export default FieldArrayItem;
